(() => {
  function preserveContext(form) {
    const current = new URL(location.href);
    if (!/\/collections\/(vendors|types)\/?$/.test(current.pathname)) return;
    if (current.searchParams.has('q') && !form.elements.namedItem('q')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'q';
      input.value = current.searchParams.get('q');
      form.append(input);
    }
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const lifecycle = new AbortController();
    const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal: lifecycle.signal });
    root.querySelectorAll('form').forEach(form => {
      preserveContext(form);
      // Keep blank fields enabled so a back/forward restore cannot leave price inputs disabled.
      listen(form, 'formdata', event => {
        form.querySelectorAll('input[type="number"]').forEach(input => {
          if (input.value === '') event.formData.delete(input.name);
        });
      });
    });
    const current = new URL(location.href);
    if (current.searchParams.has('filter.v.availability')) {
      current.searchParams.delete('filter.v.availability');
      location.replace(current.href);
      return;
    }

    const form = root.querySelector('[data-sq-filter-form]');
    const min = form?.querySelector('[name="filter.v.price.gte"]');
    const max = form?.querySelector('[name="filter.v.price.lte"]');
    const error = form?.querySelector('[data-sq-filter-error]');
    const validatePrice = () => {
      if (!min || !max) return;
      const invalid = min.value !== '' && max.value !== '' && Number(max.value) < Number(min.value);
      max.setCustomValidity(invalid ? root.dataset.priceError : '');
      if (!invalid) {
        max.removeAttribute('aria-invalid');
        if (error) { error.hidden = true; error.textContent = ''; }
      }
    };
    listen(min, 'input', validatePrice);
    listen(max, 'input', validatePrice);
    listen(window, 'pageshow', validatePrice);
    validatePrice();
    listen(form, 'invalid', event => {
      const field = event.target;
      const group = field.closest('details');
      if (group) group.open = true;
      field.setAttribute('aria-invalid', 'true');
      if (error) { error.hidden = false; error.textContent = field.validationMessage; }
      // The first invalid field owns focus, including fields inside closed filter groups.
      if (field === form.querySelector(':invalid')) field.focus({ preventScroll: false });
    }, { capture: true });
    listen(form, 'input', event => {
      if (event.target.validity?.valid) event.target.removeAttribute('aria-invalid');
      if (error && !form.querySelector(':invalid')) { error.hidden = true; error.textContent = ''; }
    });

    root.querySelectorAll('[data-sq-clear-filters]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (/\/collections\/(vendors|types)\/?$/.test(current.pathname) && current.searchParams.has('q')) {
        url.searchParams.set('q', current.searchParams.get('q'));
        link.href = url.href;
      }
    });

    const dialog = root.querySelector('[data-sq-filter-dialog]');
    const home = root.querySelector('[data-sq-filter-home]');
    const opener = root.querySelector('[data-sq-filter-open]');
    const host = root.querySelector('[data-sq-filter-host]');
    if (dialog?.showModal && form && home && opener && host) {
      const mobile = matchMedia('(max-width:749px)');
      const close = () => dialog.close();
      listen(opener, 'click', () => {
        host.append(form);
        dialog.showModal();
        opener.setAttribute('aria-expanded', 'true');
      });
      listen(dialog, 'close', () => {
        home.append(form);
        opener.setAttribute('aria-expanded', 'false');
        const target = mobile.matches ? opener : form.querySelector('summary, input:not([type="hidden"]), button');
        target?.focus({ preventScroll: true });
      });
      listen(root.querySelector('[data-sq-filter-close]'), 'click', close);
      listen(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      const responsive = () => {
        opener.hidden = !mobile.matches;
        if (!mobile.matches && dialog.open) close();
      };
      listen(mobile, 'change', responsive);
      responsive();
      root.classList.add('is-enhanced');
    }
    listen(document, 'shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      lifecycle.abort();
      if (dialog?.open) dialog.close();
      delete root.dataset.ready;
    });
  }
  document.querySelectorAll('[data-sq-facets]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sq-facets]').forEach(init));
})();
